import { Injectable } from '@angular/core';
import { IrsipModel } from '../../../../src/app/views/pages/irsip/models/Irsip-model';

@Injectable({
	providedIn: 'root'
})
export class AppFormDataService {

	public applicationId: number;
	public acronym: string;
	public taskName: string;
	public formView: string;
	public statusCodeId
	public isAdmin: boolean;
	public application: any = {};
	public isBatchActive: boolean;
	public isSaveOnly: Boolean;
	public isCategory1: Boolean;
	public isInRevision: Boolean;
	public appFormData: [];
	public irsip: IrsipModel;
	irsipDocumentList: [];
	constructor() { }
	public setApplicationId(id, acronym, formView?, isAdmin?, application?, taskName?, statusCodeId?) {
		this.applicationId = id;
		this.acronym = acronym;
		this.taskName = taskName;
		this.formView = formView;
		this.statusCodeId = statusCodeId;
		this.application = application;
		this.isAdmin = isAdmin;
	}

	public setIRSIPAppplication(data) {
		this.irsip = data;
	}
	public setIRSIPDocumentList(data) {
		this.irsipDocumentList = data;
	}
}
